// Viewport
if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, minimum-scale=1, maximum-scale=1, viewport-fit=cover">');
}else if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0){
  $('head').prepend('<meta name="viewport" content="width=1280px">');
}

// Ready Init
$(document).ready(function(){
  // Navigation Control
  var toggle = $('#nav_toggle'),
      toggleText = $('#nav_toggleText'),
      menu = $('#nav_menu'),
      navParent = '.nav_parentItem',
      navChild = '.nav_child',
      navChildToggle = $('.nav_childToggle'),
      sitemap = $('.nav_sitemap');

  function navControl(){
    if(toggle.css('display') == 'none'){
      $('html, body').css('overflow', '');
      toggle.removeClass('active');
      toggleText.text('メニュー');
      menu.removeAttr('style').find(navParent).removeClass('animation');
      $(navChild).removeAttr('style');
      navChildToggle.off();
      sitemap.off();

      $(navParent).on({
        'mouseenter': function(){ $(this).find(navChild).stop().slideDown(300, 'easeInOutQuad'); },
        'mouseleave': function(){ $(this).find(navChild).stop().slideUp(300, 'easeInOutQuad'); }
      });
    }else{
      $(navParent).off();
    }
  }navControl();
  $(window).on('resize', navControl);

  function toggleActive(){
    menu.stop().slideDown(300, 'easeInOutQuad', function(){
      $('html, body').css('overflow', 'hidden');
      toggleText.text('閉じる');
      $(this).find(navParent).each(function(i){
        $(this).delay(120*i).queue(function(){ $(this).stop().addClass('animation');});
      });
      navChildToggle.on('click', function(){
        $(this).next(navChild).stop().slideToggle(300, 'easeInOutQuad');
      });
    });
  }

  function toggleNoneActive(){
    menu.stop().slideUp(300, 'easeInOutQuad', function(){
      $('html, body').css('overflow', '');
      toggle.removeClass('active');
      toggleText.text('メニュー');
      $(this).find(navParent).removeClass('animation');
      navChildToggle.off();
      $(navChild).removeAttr('style');
    });
  }

  toggle.on('click', function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      toggleActive();
      sitemap.on('click', toggleNoneActive);
    }else{
      toggleNoneActive();
    }
  });


  // Scroll
  var href, target, position;
  $('a[href^="#"], area').on('click', function(){
    href = $(this).attr('href');
    target = $(href == "#" || href == "" ? 'html' : href);
    position = target.offset().top - 100;
    $('html, body').stop().animate({scrollTop: position}, 600, 'easeInOutQuad');
    return false;
  });


  // Back to Top
  var totop = $('#totop');
  $(window).on('scroll', function(){
    if($(this).scrollTop() > 600){totop.addClass('actv');}
    else{totop.removeClass('actv');}
  });
  totop.on('click', function(){
    $('html, body').stop().animate({scrollTop: 0}, 600, 'easeInOutQuad');
    return false;
  });


  // Form
  var rc;
  $('.form_select').customSelect();
  $('input[type=checkbox]').change(function(){
    if($(this).prop('checked')){$(this).parents('label').addClass('active');}
    else{$(this).parents('label').removeClass('active');}
  });
  $('input[type=radio]').change(function(){
    rc = 'input[name=' + $(this).attr('name') + ']';
    $(rc).parents('label').removeClass('active');
    $(this).parents('label').addClass('active');
  });


  // TOC
  var cnt = $('.toc_item').length;
  cnt = 3 - (cnt % 3);
  if(cnt != 3){
    for(var i = 1; i <= cnt; i++){
      $('.toc').append('<li class="toc_item"></li>');
     }
  }

  // Map
  $('img[usemap]').rwdImageMaps();
});

//Swiper
var swiper;
swiper = new Swiper('.top #intro', {
  autoHeight: true,
  grabCursor: true,
  threshold: 5,
  centeredSlides: true,
  slidesPerView: 'auto',
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3600,
    disableOnInteraction: false
  },
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});